import { Award, ShieldCheck, ThumbsUp, Truck } from "lucide-react";

const values = [
  {
    icon: Award,
    heading: "Curated Quality",
    description:
      "Every product is handpicked and tested by our team before it makes it into our shop.",
  },
  {
    icon: ShieldCheck,
    heading: "Secure Shopping",
    description:
      "Your data is protected with industry-standard encryption and trusted payment partners.",
  },
  {
    icon: ThumbsUp,
    heading: "Satisfaction Guaranteed",
    description:
      "Not happy with your purchase? We'll work with you to make it right — no hassle.",
  },
  {
    icon: Truck,
    heading: "Fast Shipping",
    description:
      "Quick, reliable delivery so you can start enjoying your new favorites sooner.",
  },
];

export function BrandValuesSection() {
  return (
    <section className="py-20">
      <div className="mx-auto max-w-[1360px] px-6 lg:px-10">
        <div className="grid gap-6 sm:grid-cols-2">
          {values.map((v, i) => (
            <div key={i} className="flex gap-5 p-6">
              <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center bg-bg-alt">
                <v.icon size={22} className="text-heading" />
              </div>
              <div>
                <h3 className="text-[15px] font-semibold text-heading">
                  {v.heading}
                </h3>
                <p className="mt-1.5 text-sm leading-relaxed text-text-muted">
                  {v.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
